import ClaimListing from './ClaimListing';

import type { ClaimListingProps } from './ClaimListing';

type ClaimMethodsProps = {
  phones?: Array<string>;
  emails?: Array<string>;
};
const ClaimMethods = ({ phones = [], emails = [] }: ClaimMethodsProps = {}) => ({
  phones: phones.map(String),
  emails: emails.map(String),
});

const ClaimPropertyLookupAll = ({
  totalContactMethodCount = 0,
  contactMethods = {},
  totalListingCount = 0,
  listings = [],
}: {
  totalContactMethodCount?: number;
  contactMethods?: ClaimMethodsProps;
  totalListingCount?: number;
  listings?: Array<ClaimListingProps>;
} = {}) => ({
  totalContactMethodCount: Number(totalContactMethodCount),
  contactMethods: ClaimMethods(contactMethods),
  totalListingCount: Number(totalListingCount),
  listings: listings.map(ClaimListing),
});

export default ClaimPropertyLookupAll;

export type ClaimPropertyLookupAllProps = ReturnType<typeof ClaimPropertyLookupAll>;
